import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { HookFormText } from 'components/hookForm';
import { ElevionLeafFieldID, isLeafNode } from 'utils/elevion';
import { CustomAttributeLeafValueField } from './components/customAttributeLeafValueField';
export const LeafValueField = ({ parentName, customFields, }) => {
    // TODO: [TEAMS-13693] remove omit after updating to RHF v8
    const { control } = useFormContext();
    const fieldName = `${parentName}.value`;
    const node = useWatch({
        control,
        name: parentName,
    });
    const shouldBeEmpty = isLeafNode(node) && node.comparator === 'is_empty';
    const valueType = useMemo(() => {
        // invalid node guard
        if (!isLeafNode(node))
            return null;
        const isQueueSelect = node.field === ElevionLeafFieldID.Queue;
        if (isQueueSelect)
            return 'queue-select';
        const isCustomField = isLeafNode(node) && node.field.startsWith('custom__');
        if (isCustomField) {
            const fieldIdentifier = node.field.replace('custom__', '');
            const customField = customFields.find((field) => field.identifier === fieldIdentifier);
            if (!customField)
                return null;
            return `custom-${customField.type}`;
        }
    }, [node, customFields]);
    if (!isLeafNode(node))
        return null;
    switch (valueType) {
        case 'queue-select': {
            return _jsx(_Fragment, { children: "WIP" });
        }
        case 'custom-select': {
            if (!Array.isArray(node.value))
                return null;
            return (_jsx(CustomAttributeLeafValueField, { parentName: parentName, fieldName: fieldName, customFields: customFields, disabled: shouldBeEmpty }));
        }
        case 'custom-text':
        default: {
            const placeholder = shouldBeEmpty ? 'No value needed' : 'Enter a value';
            return (_jsx(HookFormText, { name: fieldName, control: control, disabled: shouldBeEmpty, noLabel: true, noAlert: true, componentProps: {
                    placeholder,
                } }));
        }
    }
};
